import { Row, Col, AccordionItem, Accordion, AccordionBody, AccordionHeading, AccordionTitle, Typography, Icon, Link } from "@visa/vds"
import React, { useEffect, useState } from "react";
import "../DashboardPage.css"
import DashboardActionItemsDialog from "./DashboardActionItemsDialog";

const DashboardAccordion = (props) => {
    const [openDialog, setOpenDialog] = useState(false);

    let {
        accordionHeaderActionComponent,
        subtitle,
        title
    } = props

    useEffect(() => {
    }, [subtitle]);

    return (
        <>
            <DashboardActionItemsDialog
                openDialog={openDialog}
                setOpenDialog={setOpenDialog}
                accordionHeaderActionComponent={accordionHeaderActionComponent} />

            <Accordion className="dashboard-accordion" id={title}>
                <AccordionItem>
                    <AccordionHeading>
                        <Col>
                            <AccordionTitle className="vss-accordion-title-dashboard">
                                <Typography tag="h3" variant="title" id={"accordian_title_" + title}>{title}</Typography>
                                <div className="dashboard-web-view" style={{ marginRight: "5vw" }} id={title + "_status"}>{subtitle}</div>
                            </AccordionTitle>
                            <Row className="dashboard-mobile-view">{subtitle}</Row>
                            <div className="dashboard-web-view">{accordionHeaderActionComponent ? accordionHeaderActionComponent : <></>}</div>
                        </Col>
                        {accordionHeaderActionComponent &&
                            <Link className="dashboard-mobile-view icon-options-vertical" onClick={() => setOpenDialog(true)}>
                                <Icon name="options-vertical" resolution="high" />
                            </Link>}
                    </AccordionHeading>
                    <AccordionBody className="dashboard-accordion-body">
                        {props.children}
                    </AccordionBody>
                </AccordionItem>
            </Accordion >
        </>
    );
}
export default DashboardAccordion;